import { defineStore } from "pinia";
import { useUsersStore } from "./user";

export const usePostsStore = defineStore("posts", {
  state: () => ({
    posts: [],
    apiUrl: "https://yowl-community.cf-host.com/api/",
    token: "",
  }),
  actions: {
    //---------------------------action sur Posts pour CRUD--------------------------------------
    createPost(description, url, category_id) {
      const userStore = useUsersStore();
      const token = userStore.token;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        url: url,
        description: description,
        category_id: category_id,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${this.apiUrl}posts/create`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    getPosts() {
      var myHeaders = new Headers();

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(`${this.apiUrl}posts`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          this.posts = result.posts;
          console.log(this.posts.posts);
        })
        .catch((error) => console.log("error", error));
      return this.posts;
    },
  },
});
